

























































import {
  AvatarChangeModal,
  HistoryTableActivity,
  HistoryTableLevelUp,
  HistoryTableOpportunity,
  HistoryTableSkillUp,
} from '@/components/geek-profile';
import { collapseMixin } from '@/shared';
import { OneOfGeekHistoryElements, Season, HistoryType } from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(collapseMixin).extend({
  name: 'HistoryTab',
  props: {
    showFilters: {
      type: Boolean,
      default: true,
    },
    activeSeason: Object as () => Season,
  },
  components: {
    HistoryTableActivity,
    HistoryTableLevelUp,
    HistoryTableOpportunity,
    HistoryTableSkillUp,
  },
  data() {
    return {
      showOnlyActivities: true,
      loader: {
        isHistoryListPending: false,
      },
    };
  },
  created() {
    if (this.activeSeason && this.activeSeason.id) {
      this.fetchGeekHistory();
    }
  },
  computed: {
    collapsibleItems(): OneOfGeekHistoryElements[] {
      return typedStore(this).state.history.geekHistory;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.history.pagination.totalCount
        && this.collapsibleItems.length > 0;
    },
  },
  methods: {
    async fetchGeekHistory() {
      this.loader.isHistoryListPending = true;
      try {
        await this.$store.dispatch(
          Actions.history.fetchGeekHistory,
          {
            geekId: this.$route.params.geekId,
            seasonId: this.activeSeason.id,
            showOnlyActivities: this.showOnlyActivities,
          },
        );
      } finally {
        this.loader.isHistoryListPending = false;
      }
    },
    async loadMoreElements() {
      this.loader.isHistoryListPending = true;
      try {
        await this.$store.dispatch(
          Actions.history.fetchMoreGeekHistory,
          {
            geekId: this.$route.params.geekId,
            seasonId: this.activeSeason.id,
            showOnlyActivities: this.showOnlyActivities,
          },
        );
      } finally {
        this.loader.isHistoryListPending = false;
      }
    },
    getComponentName(historyElement: OneOfGeekHistoryElements) {
      switch (historyElement.historyType) {
        case HistoryType.Skill:
          return 'HistoryTableSkillUp';
        case HistoryType.Level:
          return 'HistoryTableLevelUp';
        case HistoryType.Activity:
          return 'HistoryTableActivity';
        case HistoryType.Opportunity:
          return 'HistoryTableOpportunity';
        default:
          throw new Error('History element type is not valid');
      }
    },
  },
  watch: {
    showOnlyActivities() {
      this.fetchGeekHistory();
    },
    activeSeason() {
      this.fetchGeekHistory();
    },
  },
});
